<template>
	<svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-success">
		<path d="M32.5 18L21.5 29L16.5 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		<rect x="1.5" y="1" width="46" height="46" rx="23" stroke-width="2"/>
	</svg>

</template>

<script setup lang="ts">

</script>

<style lang="scss" scoped>
.icon-success{

}
</style>